/**
 * paansaction.js
 * Created by Vikas Gore on 14/08/2020.
 * manage the store user object
 */
import * as types from '../actiontypes';
import {promiseAreas} from './../../util/uiconstants';

/**
 * @param {String} url - the api url
 * @return {Function} Thunk function
 */
export function checkUserAcceptedPaansPolicy(url) {
	return {
		type: types.CHECK_USER_ACCEPTED_PAANS_POLICY,
		meta: {
			api: {
				url,
				method: 'GET',
				trackWithArea: promiseAreas.USER_SETTINGS_AREA
			}
		}
	};
}
